import { Box } from '@chakra-ui/react'
import React, { FC } from 'react'

export interface InformationPanelProps {
  total?: number
}

export const InformationPanel: FC<InformationPanelProps> = ({ total }) => {
  return (
    <Box className="page-sub-title" color="neutral.70" fontSize="body">
      {total || 0} items
    </Box>
  )
}
InformationPanel.displayName = 'ListPage.InformationPanel'
